module.exports = __webpack_public_path__ + "img/about.9033e547.png";